import { Typography } from '@mui/material';
import * as React from 'react';

export const InterventionPeriodsPage: React.FunctionComponent = () => {
    return <Typography>InterventionPeriods page: Work in progress</Typography>;
};
